<template>
	<c-dialog ref="dialog" width="500" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="editHandle">
		<c-tips v-if="saasInfo.max_v_account_count>0">员工账号最多可创建{{saasInfo.max_account_count}}个，虚拟账号{{saasInfo.max_v_account_count}}个</c-tips>
		<c-tips v-else>员工账号最多可创建{{saasInfo.max_account_count}}个</c-tips>
		
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="账号类型" required v-show="saasInfo.max_v_account_count>0">
				<c-select v-model="user_type" name="user_type" :options="userTypeDic" :disabled="editState"></c-select>
				<template #handle>
					<c-tooltip align="end"  width="260" tip="">
						<template #tip>
							<p>类型说明：</p>
						    <p>员工：允许登陆系统，占用系统账号数量</p>
							<p>虚拟：不允许登陆系统，一般用于替非正式员工代报工，不占用账号数量</p>
						</template>
					</c-tooltip>
				</template>
			</c-form-item>
			<c-form-item label="账号" required>
				<c-input name="user_name" maxlength="20" :disabled="is_manage"></c-input>
			</c-form-item>
			<c-form-item label="姓名" required>
				<c-input name="user_realname" maxlength="10" ></c-input>
			</c-form-item>
			<c-form-item label="手机号码">
				<c-input name="phone" maxlength="11" ></c-input>
			</c-form-item>
			<c-form-item label="默认计价方式" required>
				<c-select name="pricing_type" :options="pricingTypeDic" :clear="false"></c-select>
				<template #handle>
					<c-tooltip align="end"  width="380" tip="">
						<template #tip>
							<p>默认计价方式说明：</p>
							<p>报工时，作为默认工资计算方式</p>
							<p>报工时，默认不支持员工切换计价方式，如需允许，可以前往
							<p>（生产管理->报工->报工页配置->开启【计价方式】字段->配置->允许员工切换计价方式）</p>
						    <p>计件：员工报工时，按报工数量计算工资</p>
							<p>计时：员工报工时，按报工时长计算工资</p>
						</template>
					</c-tooltip>
				</template>
			</c-form-item>
			<c-form-item label="角色" v-show="!user_type || user_type==1" required>
				<c-select name="role_ids" async multiple @search="searchRole" :value-data="selectedRole" :disabled="is_manage"></c-select>
				<template #handle>
					<c-tooltip align="end" tip="提示信息" width="260">
					    <template #tip>
							<p>角色说明：</p>
					        <p>1、系统会按照角色初始化账号权限
							<p>2、如需调整用户权限，请在用户列表按PC、手机端分别设置</p>
							<p>3、轻量-管理员、系统管理员角色拥有同组用户报工审批权限（需要有代报工权限）</p>
					    </template>
					</c-tooltip>
				</template>
			</c-form-item>
			<c-form-item label="部门">
				<c-select name="department_ids" async multiple @search="searchDepartment" :value-data="selectedDepartment"></c-select>
				<template #handle>
					<c-link icon v-if="auth('b_department_edit')" @click="$refs.departmentEdit.open()">创建部门</c-link>
				</template>
			</c-form-item>
			<c-form-item label="身份" v-show="!user_type || user_type==1" >
				<c-select name="identity" async multiple @search="searchIdentity" :value-data="selectedIdentity"></c-select>
				<template #handle>
					<c-tooltip align="end"  width="260" tip="">
						<template #tip>
							<p>身份说明：</p>
						    <p>拥有老板或对接人身份的人,系统有新功能更新后会自动拥有相关权限</p>
						</template>
					</c-tooltip>
				</template>
			</c-form-item>
			<!--自定义字段控件-->
			<custom-form ref="customForm" work-type="27"></custom-form>
		</c-form>
		
		<!--创建/编辑部门弹窗-->
		<department-edit ref="departmentEdit"></department-edit>
	</c-dialog>
</template>

<script>
import departmentEdit from "./department_edit.vue";
import {mapState, mapGetters} from "vuex";
export default {
	components: {
		departmentEdit
	},
	
	data() {
		return {
			editState:false,
			user_type:1,
			selectedRole:[],
			selectedDepartment:[],
			selectedIdentity:[],
			is_manage:false   //是否超级管理员（1：是，2：否）
		}
	},

	computed: {
		...mapState(['systemConfig', 'userTypeDic', 'saasInfo', 'pricingTypeDic']),
		...mapGetters(['freeEdition']),
	},

	methods: {
		/*********打开编辑框，初始化**********/
		async open(data) {
			this.editState = !!data;
			if (!this.editState && !(await this.checkDataCount('SYSTEM_USER')).data) return;
			this.is_manage = false;
			this.$refs.form.clear();
			this.$refs.customForm.init();
			if (data) {
				//查询部门详情
				this.request({
					url:'/sys_user/detail',
					data: {
						id:data.id
					},
					success:data => {
						this.$refs.form.set(data.detailInfo);
						this.is_manage = data.detailInfo.is_manage==1?true:false;
						//已选中的[角色]
						this.selectedRole = data.roleList.map(item => {
							return {
								name:item.role_name,
								value:item.role_id
							}
						});
						//已选中的[部门]
						this.selectedDepartment = data.departmentList.map(item => {
							return {
								name:item.department_name,
								value:item.id
							}
						});
						//已选中的身份
						if (data.detailInfo.identity){
							this.selectedIdentity = data.detailInfo.identity.split(',').map(item => {
								return {
									name:item,
									value:item
								}
							});
						}
					}
				})
			}else{
				this.$refs.form.set({
					user_type: 1,
					pricing_type: 1
				});
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑用户' : '创建用户'
			});
		},

		/*******搜索角色*****************/
		searchRole(keyword, resolve){
			this.request({
				url:'/system/native/options',
				data: {
					options_code:'ROLE'
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索部门*****************/
		searchDepartment(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'DEPARTMENT',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索身份********/
		searchIdentity(keyword, resolve){
			this.request({
				url:'/system/native/options',
				data: {
					options_code:'IDENTITY'
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/sys_user/edit':'/sys_user/add',
				rule: {
					user_type: '请选择账号类型',
					user_name: '请输账号',
					user_realname: '请输姓名',
					pricing_type: '请选择计价方式',
					role_ids: data => { 
						var flag = true;
						if(this.user_type == 1 && data.role_ids.length==0){
							let msg = "请选择角色";
							return msg;
						}
						return flag;
					},
					...this.$refs.customForm.rule
				},
				dataFormatter: data => {
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
					data.identity = data.identity?data.identity.join(','):'';
					return data;
				},
				success: (data, res) => {
					next();
					if (this.editState){//编辑
						this.$message({
							message: '编辑成功',  // 提示内容,
							type: 'success'
						});
					}else {//新增
						this.$confirm({
							message: res,
							buttonName: '我知道了',
							cancelButton: false,
							resolve: () => {
							}
						});
					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>